Vue.component("MainMenu", {
    props: ["settings", "isFullscreen"],
    template: `
        <transition name="menuanimation" v-if="settings.enabled">
            <div class="menuContainer">
                <nav id="main-menu" v-show="menuReady" 
                    :class="{'main-menu--hidden': menuHidden}"
                    :style="[{width: (bigNavElements == 0 && keepWidth) ? 'auto' : 'calc(100% - 92px)'}, menuPlacement]">
                    <transition name="menuanimation">
                        <div class="main-menu__showmenu main-menu__showmenu--active" @click="toggleMenu" v-show="menuHidden">
                            <img src="assets/img/ui/arrowup.png">
                        </div>    
                    </transition>

                    <ul class="main-menu__navigation">
                        <li v-for="nav in menuElements"
                            :class="[setNativeNavClass(nav), isActiveNav(nav), backButtonDisabled(nav), isFullscreenButton(nav)]"
                            :style="individualNavWidth(nav)"
                            @click="handleClick">
                            <span class="main-menu__navigation_title" v-if="nav.title">
                                {{nav.title}}
                                <img class="main-menu__navigation_extlinkimg" src="assets/img/ui/ext-link.png" v-if="nav.type == 'externallink'">
                            </span>  
                            <div class="main-menu__navigation_img" v-else></div>
                        </li>
                    </ul>
                    <div class="breadcrumbs__wrapper">
                        <span  v-for="crumb in breadcrumbs" @click="gotoRoute(crumb.route)">{{crumb.title}}</span>
                    </div>
                </nav>
            </div>
        </transition>
    `,
    data() {
       

        return {
            menuElements: [],
            //customization variables from config.js
            alignRight: this.settings.alignRight ? this.settings.alignRight : false,
            alignBottom: this.settings.alignBottom ? this.settings.alignBottom : true,
            keepWidth: this.settings.keepWidth,
            
            // variables for this instance of the main menu
            menuHidden: false,
            menuReady: false,
            bigNavElements: 0,
            
        }
    },
    created() {
        // do a count for how many big navigation elements there are, to then assign width to them.
        this.findBigNavElements();
        this.initNavigation()
    },
    mounted() {
        // intro animation when scene is ready.
        this.menuReady = true;
    },


    methods: {

        initNavigation() {
            // if manifest has a menu object, send it to the main menu component
            if(app.settings.has("menu"))
                this.menuElements = app.settings.get('menu').value
        },

       

        handleClick(e) {
            // a click handler based on the classes assigned from setNativeNavClass(). 

            let classlist = e.target.classList

            for (var i = 0; classlist.length > i; i++) {

                    // is internal navigation
                if (classlist[i].slice(0, 11) == "navigateto_") {
                    this.navGoto(classlist[i].substring(11));

                    // is external navigation
                } else if (classlist[i].slice(0, 14) == "extnavigateto_") {
                    this.openLink(classlist[i].substring(14));

                    //function calls
                } else if (classlist[i].substring(11) == "home") {
                    this.home();
                } else if (classlist[i].substring(11) == "back") {
                    this.back();
                } else if (classlist[i].substring(11) == "fullscreen") {
                    this.fullscreen();
                } else if (classlist[i].substring(11) == "togglemenu") {
                    this.toggleMenu();
                }
            }
            
        },
        home() {
           app.router.home();
        },
        back() {
          app.router.back();
        },
        fullscreen() {
            app.radio.$emit("app-fullscreen-toggle");
        },
        toggleMenu() {
            // hide / unhide menu
            this.menuHidden = !this.menuHidden;
        },
        openLink(url) {
            // handler for external links, opens in new tab.
            window.open(url, "_blank");
        },
        navGoto(route) {
            // navigates to the navigation elements specified route from the settings.menu object in manifest.json.
            if (this.$router.currentRoute.path !== route)
                this.$router.push(route);
        },
        isActiveNav(nav) {
            // check route to see if this nav element is an active nav element; meaning a check to see if the user is currently in this
            // part of the manifest branch. assigns '--active' class which can be customized through css.
            if (nav.hasOwnProperty("route")) {
                var currentRoute = this.$router.currentRoute.path;
                if (this.atHomePage) return;
                if (touchKit.utils.isChildRouteOf(nav.route, currentRoute)) {
                    return "main-menu__navigation_nav--active"
                }
            }
        },
        setNativeNavClass(nav) {
            // assign classes to the navigation elements based on the settings.menu data in manifest.json.
            // this is then used as hooks for styling and click events.
            var type = type || "";
            let navtype = "main-menu__" + type
            let islink = !type.endsWith("link") ? "main-menu__navigation_smallnav" : "main-menu__navigation_nav"
            let navigatesto = nav.hasOwnProperty("route") ? "navigateto_" + nav.route : ''
            let externalnavigatesto = nav.hasOwnProperty("url") ? "extnavigateto_" + nav.url : ''

            return navtype + " " + islink + " " + navigatesto + " " + externalnavigatesto
        },

        individualNavWidth(nav) {
            // assign width of the wide elements in navigation based on findBigNavElements() count.
            if (nav.type == 'internallink' || nav.type == 'externallink')
                return 'width:calc((100% / ' + this.bigNavElements + ') - ' + ((this.menuElements.length - this.bigNavElements) * 70) / this.bigNavElements + 'px)'
        },

        findBigNavElements() {
            // a count to find how many wide menu elements there are to be used to assign width to them.
            let n = 0;
            for (var i = 0; this.menuElements.length > i; i++) {
                if (this.menuElements[i].type == 'internallink' || this.menuElements[i].type == 'externallink') {
                    n++;
                }
            }
            this.bigNavElements = n;
        },

        backButtonDisabled(nav) {
            // disable back button if the app is at home page.
            if (nav.type == "back" && this.atHomePage) {
                return 'main-menu__back--disabled';
            }
        },

        isFullscreenButton(nav) {
            // a hook for the fullscreen button to change to a "minimize" styling.
            if (this.isFullscreen && nav.type == "fullscreen") {
                return "main-menu__fullscreen--active"
            }
        },
        gotoRoute(route) {

            if(this.$route.path !== route) {
                this.$router.push(route)
            }
        }
    },
    computed: {
        // place menu based on variables set in config.js
        menuPlacement() {
            return {
                top: this.alignBottom ? 'auto' : '20px',
                bottom: this.alignBottom ? '20px' : 'auto',

                right: this.alignRight ? '46px' : 'auto',
                left: this.alignRight ? 'auto' : '46px',
            }
        },

        breadcrumbs () {
           return touchKit.PageManager.breadCrumbs(this.$route.fullPath);
        },
        rootPath () {
            return app.router.defaultRoute;
        },
        atHomePage() {
            return this.$route.path == app.router.defaultRoute;
        }
        
    },
})